import React from 'react';
import { useHistory } from 'react-router-dom';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const emailValue = React.useRef(null);
  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email: emailValue.current.value,
    };
    return data;
  };
  const history = useHistory();
  function goToOTP() {
    history.push('/otpcode');
  }

  return (
    <div className="forgot_pswd_container">
      <div className="forgot_pswd">
        <h2>Forgot Password</h2>
        <p>
          Please enter your registered email address, we will get back to you
          with the confirmation OTP and further instructions on how to reset
          your password.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email">
            <input
              type="email"
              name="email"
              className="register_email"
              required="required"
              ref={emailValue}
              placeholder="Email Address"
            />
          </label>

          <input
            type="submit"
            value="Reset Password"
            className="btn"
            onClick={goToOTP}
          />
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
